/**
 * 고객 API
 */
import { apiNa } from "@/redworks/api/index";

const CUSTOMER_API = "/v1/customer";
function $rejectAcceptEmail(rejectInfo) {
  const rejectDto = {
    rejectInfo: encodeURIComponent(rejectInfo)
      .replace(/%20/g, "+")
      .replace(/%2F/g, "/"),
  };
  return apiNa.put(`${CUSTOMER_API}/reject`, rejectDto);
}

function $createRequestParam(returnUrl) {
  const data = {
    returnUrl: returnUrl,
  };
  const queryString = Object.keys(data)
    .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(data[k]))
    .join("&");
  return apiNa.post(`${CUSTOMER_API}/identify/key?${queryString}`);
}

function $getResData(params) {
  return apiNa.post(`${CUSTOMER_API}/identify/decode`, params);
}

function $isUsableLoginId(loginId) {
  return apiNa.get(`${CUSTOMER_API}/validate-identity/${loginId}`);
}

function $isUsableIdentifyValue(verifyIdVal) {
  return apiNa.get(`${CUSTOMER_API}/validate-verify`, {
    params: { ci: verifyIdVal },
  });
}

function $signupCustomer(params) {
  return apiNa.post(`${CUSTOMER_API}/sign-up`, params);
}

function $withdrawCustomer(params) {
  return apiNa.delete(`${CUSTOMER_API}/withdraw`, params);
}

function $changeActive(custId) {
  return apiNa.put(`${CUSTOMER_API}/active/${custId}`);
}


export {
  $rejectAcceptEmail,
  $createRequestParam,
  $getResData,
  $isUsableLoginId,
  $signupCustomer,
  $withdrawCustomer,
  $changeActive,
  $isUsableIdentifyValue,
  
};
